import { Chip, Stack, Tooltip, Typography } from '@mui/material';

export function OtherTags({ tags }: { tags: string[] }) {
  const title = (
    <Stack direction="column" spacing={1}>
      {tags.map((t) => (
        <Typography key={t} variant="inherit">
          {t}
        </Typography>
      ))}
    </Stack>
  );

  return (
    <Tooltip title={title} arrow placement="top">
      <Chip label={`+${tags.length}`} size="small" variant="outlined" />
    </Tooltip>
  );
}
